import { render, staticRenderFns } from "./KeywordTag.vue?vue&type=template&id=0b2f562e&functional=true"
import script from "./KeywordTag.vue?vue&type=script&lang=js"
export * from "./KeywordTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports